<template>
  <SectionListMetric014
    v-if="contextData"
    :title="contextData.title"
    :description="contextData.description"
    :number-of-line="contextData.numberOfLine"
    :items="contextData.items"
  />
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    subtitle: string;
    description: string;
  }

  interface IListMetricsStackedData {
    title: string;
    description?: string;
    numberOfLine: 3 | 4;
    items: IItem[];
  }

  interface IListMetricsStacked {
    component: 'list-metrics-stacked';
    meta: {
      navigable?: string;
    };
    data: IListMetricsStackedData;
  }

  type IProps = ISuiteProps<IListMetricsStacked>;

  const props = defineProps<IProps>();

  const contextData = computed(
    (): IListMetricsStackedData => props.suiteData.data
  );

  export type { IItem, IListMetricsStacked, IListMetricsStackedData };
</script>
